import { render, staticRenderFns } from "./tbFrmChgOfContDtl.vue?vue&type=template&id=04ef3c70"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports